import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService"
import {
  getAnswerList,
  saveAnswerList,
  getQuestionnaire,
  saveQuestionnaireAnswers,
} from "../../services/QuestionnaireService"
import {
  FETCH_QUESTIONNAIRE_REQUEST,
  FETCH_QUESTIONNAIRE_SUCCESS,
  FETCH_QUESTIONNAIRE_FAILURE,
  SUBMIT_QUESTIONNAIRE_REQUEST,
  SUBMIT_QUESTIONNAIRE_SUCCESS,
  SUBMIT_QUESTIONNAIRE_FAILURE,
} from "./QuestionnaireTypes"

// Action Types
export const FETCH_ANSWERS_REQUEST = "FETCH_ANSWERS_REQUEST"
export const FETCH_ANSWERS_SUCCESS = "FETCH_ANSWERS_SUCCESS"
export const FETCH_ANSWERS_FAILURE = "FETCH_ANSWERS_FAILURE"
export const SAVE_ANSWERS_REQUEST = "SAVE_ANSWERS_REQUEST"
export const SAVE_ANSWERS_SUCCESS = "SAVE_ANSWERS_SUCCESS"
export const SAVE_ANSWERS_FAILURE = "SAVE_ANSWERS_FAILURE"

// Action Creators
export const fetchAnswersRequest = () => ({
  type: FETCH_ANSWERS_REQUEST,
})

export const fetchAnswersSuccess = (answers) => ({
  type: FETCH_ANSWERS_SUCCESS,
  payload: answers,
})

export const fetchAnswersFailure = (error) => ({
  type: FETCH_ANSWERS_FAILURE,
  payload: error,
})

export const saveAnswersRequest = () => ({
  type: SAVE_ANSWERS_REQUEST,
})

export const saveAnswersSuccess = (response) => ({
  type: SAVE_ANSWERS_SUCCESS,
  payload: response,
})

export const saveAnswersFailure = (error) => ({
  type: SAVE_ANSWERS_FAILURE,
  payload: error,
})

export const fetchQuestionnaire = (leadId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_QUESTIONNAIRE_REQUEST })

    try {
      const response = await getQuestionnaire(leadId)
      console.log("API Response:", response.data)
      console.log("API Response data length:", response.data.data?.length)

      if (response.data.status === "success") {
        // Pass the data directly without transformation
        console.log("Dispatching questionnaire data:", response.data.data)
        dispatch({
          type: FETCH_QUESTIONNAIRE_SUCCESS,
          payload: {
            fields: response.data.data,
            answers: {},
          },
        })
      } else {
        throw new Error(response.data.message || "Failed to fetch questionnaire")
      }
    } catch (error) {
      dispatch({
        type: FETCH_QUESTIONNAIRE_FAILURE,
        payload: error.message,
      })
      showErrorAlert(error.message)
    }
  }
}

export const submitQuestionnaire = (leadId, answers, formId) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_QUESTIONNAIRE_REQUEST })

    try {
      // Format answers for API
      const formattedAnswers = answers.map((answer) => {
        const groupId = answer.group_id || "0"
        return {
          ...answer,
          group_id: groupId,
        }
      })

      const payload = {
        lead_id: leadId,
        answers: JSON.stringify(formattedAnswers),
      }

      const response = await saveQuestionnaireAnswers(payload)

      if (response.data.status === "success") {
        // Transform the answers array back to an object format for the state
        const answersObject = formattedAnswers.reduce((acc, answer) => {
          acc[answer.question_id] = answer.answer
          return acc
        }, {})

        dispatch({
          type: SUBMIT_QUESTIONNAIRE_SUCCESS,
          payload: answersObject,
        })

        return response.data
      } else {
        throw new Error(response.data.message || "Failed to submit questionnaire")
      }
    } catch (error) {
      dispatch({
        type: SUBMIT_QUESTIONNAIRE_FAILURE,
        payload: error.message,
      })
      showErrorAlert(error.message)
      throw error
    }
  }
}

// Thunk Actions
export const fetchAnswers = (payload) => {
  return async (dispatch) => {
    dispatch(fetchAnswersRequest())
    try {
      const response = await getAnswerList(payload)
      dispatch(fetchAnswersSuccess(response.data.data))
    } catch (error) {
      dispatch(fetchAnswersFailure(error.message))
    }
  }
}

export const saveAnswers = (payload, navigate) => {
  return async (dispatch) => {
    dispatch(saveAnswersRequest())
    try {
      const response = await saveAnswerList(payload)
      dispatch(saveAnswersSuccess(response.data))

      if (!response.data || response.data.status !== "success") {
        throw new Error("Failed to save answers: " + (response.data.message || "Unknown error"))
      } else {
        await handleSuccess("Answers saved successfully!")
        if (navigate && payload.patient_id) {
          navigate(`/patients/patient-details/${payload.patient_id}`)
        }
      }

      return response.data
    } catch (error) {
      dispatch(saveAnswersFailure(error.message))
      showErrorAlert("Failed to save answers. Please try again.")
      throw error
    }
  }
}
